module.exports = __webpack_public_path__ + "static/favicon-54f90f4d6d8f65e6eeec70df06853a65.png";